<div *ngIf="enableKsefFeatures && !hasConnectionConfig && !isLoading" 
     class="rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 p-5 text-white shadow-lg">
  <div class="flex items-start gap-4">
    <div class="w-12 h-12 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center flex-shrink-0">
      <mat-icon class="!w-6 !h-6 text-white" [svgIcon]="'tabler_outline:file-certificate'"></mat-icon>
    </div>
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2 flex-wrap mb-1">
        <h4 class="font-semibold text-lg">Skonfiguruj KSeF</h4>
      </div>
      <p class="text-sm text-blue-100 mb-4">
        Od <strong class="text-white">1 kwietnia 2026</strong> obowiązkowe wysyłanie faktur do KSeF. Połącz konto Fakturnia z KSeF.
      </p>
      
      <div class="flex flex-wrap gap-2">
        <button mat-flat-button 
                class="!bg-white !text-blue-600 hover:!bg-blue-50 !rounded-lg !text-sm !font-medium"
                (click)="openTokenDialog()">
          <mat-icon class="!w-4 !h-4 text-blue-600" [svgIcon]="'tabler_outline:settings'"></mat-icon>
          <span class="ml-1.5">Skonfiguruj połączenie</span>
        </button>
        <a mat-button [routerLink]="'/konto/ksef'" class="!text-white hover:!bg-white/10 !rounded-lg !text-sm">
          <span>Dowiedz się więcej</span>
          <mat-icon class="!w-4 !h-4 ml-1 text-white" [svgIcon]="'tabler_outline:arrow-right'"></mat-icon>
        </a>
      </div>
    </div>
    
    <!-- Dismiss button -->
    <!-- <button mat-icon-button class="!w-8 !h-8 !text-white/60 hover:!text-white hover:!bg-white/10 !rounded-lg -mt-1 -mr-1">
      <mat-icon class="!w-4 !h-4 text-white" [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button> -->
  </div>
</div>
